export default __webpack_public_path__ + "static/media/logoISQ.63b6d26b.gif";